import { useTelephonyContext } from '../../../../../contexts/TelephonyContext';
import TelephonyTopPanel from './TelephonyTopPanel';
import { Box } from '@coolblue-development/freddy';

const TelephonyPage = (): JSX.Element => {
  const { selectedRecentCall } = useTelephonyContext();

  return (
    <Box>
      <TelephonyTopPanel selectedRecentCall={selectedRecentCall} />
    </Box>
  );
};

export default TelephonyPage;
